import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/fair-harbor@fiferries.jpg';
// import BeachCard from '../../components/Cards/beach';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Fair Harbor"
      meta={[
        { name: 'description', content: 'Community on Fire Island with quaint walkways and fine dining.' },
        { name: 'keywords', content: 'Fair Harbor, Fire Island, New York, Long Island, Ferries, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Fair Harbor">
        <h2>Communities</h2>
        <h1>Fair Harbor</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('Fair Harbor').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="/schedules/fair-harbor">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Fair Harbor</h1>
          </div>
          <p>
            Fair Harbor is a community of quaint walkways tucked behind a protective cove to the west.  From the ferry dock people are steps away from the center of town. The bay beach is where parents and lifeguards alike oversee the kids at play, and where many learn to swim.  Beside the bay beach, the freight house, wagon park, and seasonal garden shop are located on the ferry dock. 
          </p>
          <p>
            Fair Harbor and other island residents get to enjoy the Pioneer Market and Unfriendly’s Ice Cream,  as well as a small variety where people can find anything from souvenirs, bikes, and household fix-it items to fishing rods and bait.  In addition to these shops there is a small Wine and Liquor store, The Loading Dock, as well as a fine dining restaurant charmingly named Le Dock, which also has a takeout pizza place attached to it.  
          </p>
        </div>
        <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 21, 2018" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div>
      </div>
      <Tip title="Captain's Tip">
        Unfriendly’s window is the best for a tasty frozen treat or a delicious egg sandwich.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Fair Harbor is available by Fire Island Ferries from Bay Shore.  <Link to="/schedules/fair-harbor">Click here for schedules.</Link>
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from Fair Harbor during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
